<!-- NoticeUserSearch -->

<template>
  <el-select
    multiple
    filterable
    remote
    value-key="id"
    :remote-method="loadTicketUserList"
    v-model="valueData"
    @change="onChange"
    @visible-change="onVisibleChange"
    placeholder="输入名字或账号搜索" 
    :style="css">
    <el-option v-for="item in ticketUserOptionList"
      :key="item.id"
      :label="item.label"
      :value="item"/>
  </el-select>
</template>

<script>
import CacheUtil from '@/assets/utils/CacheUtil';

export default {
    name: 'NoticeUserSearch',

    data() {
      return {
        valueData : [],
        ticketUserOptionList : []
      }
    },

    props: ['id','css', 'value'],

    watch: {
      id: function() {
        this.onIdChange();
      },

      value: function( _new, _old) {
        // console.log('#42 _new=', _new, ', _old=', _old);

        this.onValueChange();
      }
    },

    // 疑似 Element bug 处理
    updated() {
      this.onUserUpdated();
    },

    mounted() {
      var _val = localStorage.getItem(CacheUtil.TicketUserListCache) || "[]";
      var _ticketUserList = JSON.parse(_val);

      this.ticketUserOptionList.push(...this.userDistinct_0(_ticketUserList));

      this.onValueChange();
    },

    methods: {
      onVisibleChange() {
        setTimeout(() => {
          $('div.el-select-dropdown.el-popper').css('z-index', 20000);
        }, 100);
      },

      onValueChange() {
        if ( !this.value ) {
          return;
        }

        if ( this.value.indexOf('[') < 0 ) {
          var _ids = JSON.parse('[' + this.value + ']');
        } else {
          var _ids = JSON.parse(this.value);
        }

        var _this = this;
        sdk.TicketUserApi().listByIds({
          ids : _ids
        }).then(res => {
          _this.localStorage_up(res);

          _this.setList(res);
        });
      },

      onIdChange() {
        if ( this.id.length == 0 ) {
          this.valueData = [];
        }
      },

      addList( _list ) {
        this.valueData.push(..._list);
      },

      setList( _list ) {
        this.valueData = [];

        this.valueData.push(..._list);

        this.onVisibleChange();
      },

      //获取用户列表
      loadTicketUserList( _query ) {
        var _this = this;
        sdk.TicketUserApi().search({
          key : _query
        }).then(res => {
          if( !!res ) {
            _this.ticketUserOptionList = res.map(_this.userWithLabel);
          }
        });
      },

      localStorage_up( uList ) {
        uList = uList.map(this.userWithLabel);

        var _val = localStorage.getItem(CacheUtil.TicketUserListCache) || "[]";
        var _ticketUserList = JSON.parse(_val);

        var _val2 = JSON.stringify(this.userDistinct_0(uList.concat(_ticketUserList)));
        localStorage.setItem(CacheUtil.TicketUserListCache, _val2);
      },

      // 选中, item 为 user list
      onChange( item ) {
        // console.log('#111 onChange, item=', item, ', this=', this);

        this.localStorage_up(item);

        var uids = item.map(e => e.id);
        this.$emit('input', uids); // input 在 change 前
        this.$emit('change', item);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ticket/NoticeUserSearch.vue